import types from "resources/types";
import { createResourceListQuery } from "queries";

export const predictorsQueryWithConfig = (config = {}) =>
  createResourceListQuery(types.PREDICTORS, {
    url: "/api/v2/predictors/?limit=999",
    ...config,
  });
